
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import { Observer } from 'mobx-vue'
import { EnumMyAccountMenu } from '@xt/client/enums/my'

@Observer
@Component({
  components: {
    InfiniteLoading
  }
})
export default class MyAccountBishan extends Vue {
  expireTime: number = 0

  get pagePagination() {
    return this.$store.$myV2.Account.BiShan.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  @Emit('change-menu')
  goExchange() {
    return EnumMyAccountMenu.Exchange
  }

  async init() {
    const { expireTime } = await this.$store.$myV2.Account.BiShan.getExpireTime()
    this.expireTime = expireTime
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
